// extracted by mini-css-extract-plugin
module.exports = {"container":"kAPQLFqp","entityHeaderWatchlist":"TxZ9yqeJ"};